/**
 * Sample Types API Endpoints
 *
 * Sample types are scoped to a single instrument and identified by the
 * dual natural key (sampleCode, mappingKey) — both required for any
 * GET-by-key, PUT, or DELETE operation.
 */

export const SAMPLE_TYPES_ENDPOINTS = {
  /** GET — list sample types for an instrument, POST — create. */
  SAMPLE_TYPES: (instrumentId: number) => `/instruments/${instrumentId}/sample-types`,

  /** GET — fetch a single sample type by its dual natural key. */
  SAMPLE_TYPE_BY_KEYS: (instrumentId: number, sampleCode: string, mappingKey: string) =>
    `/instruments/${instrumentId}/sample-types/${encodeURIComponent(sampleCode)}/${encodeURIComponent(mappingKey)}`,

  /** PUT — update only the friendly `name`. Path identifies the row by (sampleCode, mappingKey). */
  UPDATE_SAMPLE_TYPE: (instrumentId: number, sampleCode: string, mappingKey: string) =>
    `/instruments/${instrumentId}/sample-types/${encodeURIComponent(sampleCode)}/${encodeURIComponent(mappingKey)}`,

  /** DELETE — remove a sample type by its dual natural key. */
  DELETE_SAMPLE_TYPE: (instrumentId: number, sampleCode: string, mappingKey: string) =>
    `/instruments/${instrumentId}/sample-types/${encodeURIComponent(sampleCode)}/${encodeURIComponent(mappingKey)}`,
} as const;
